var styles = {
  "youtubePlayer": "ktl-youtube-player-module_youtube-player_aSb0a",
  "preview": "ktl-youtube-player-module_preview_SuIdr",
  "previewPlaylist": "ktl-youtube-player-module_preview-playlist_k6-Zp",
  "player": "ktl-youtube-player-module_player_nH-tB",
  "playButton": "ktl-youtube-player-module_play-button_SNPG7",
  "playButtonWhite": "ktl-youtube-player-module_play-button_white_jsj-J",
  "playButtonBlack": "ktl-youtube-player-module_play-button_black_N4JvM",
  "playButtonPrimary": "ktl-youtube-player-module_play-button_primary_rk5oW",
  "hide": "ktl-youtube-player-module_hide_w9Dr2",
  "imagePreview": "ktl-youtube-player-module_image-preview_qXCFf",
  "showVideo": "ktl-youtube-player-module_show-video_Y1Ri-",
  "iconLoading": "ktl-youtube-player-module_icon-loading_9jAhI",
  "iconRotating": "ktl-youtube-player-module_icon-rotating_Zyb5v"
};
export { styles as default };
